module.exports = __webpack_public_path__ + "annualreview2017/static/img/gender-mix@2x.c0f0cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transparency/gender-mix@2x.png
// module id = 157
// module chunks = 0